function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Actions_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  className: "Actions_svg__a",
  transform: "translate(22 389)",
  d: "M0 0h24v24H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "Actions_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  className: "Actions_svg__c",
  d: "M5.75 21.5a.751.751 0 01-.74-.626l-.981-5.886a5.383 5.383 0 01-1.349-.912.753.753 0 01-.137-.132A5.207 5.207 0 011 10.25a5.234 5.234 0 014.667-5.2l10.045.034c.91-.055 3.829-1.76 5.621-2.962a.751.751 0 01.771-.039.749.749 0 01.4.662v16a.749.749 0 01-.428.678.751.751 0 01-.8-.1c-1.687-1.382-4.547-3.327-5.625-3.327l-6.652.039.765 4.585a.754.754 0 01-.168.608.751.751 0 01-.572.266zm.636-1.5h1.749l-.675-4.047a9.588 9.588 0 01-1.812-.381zm9.26-5.5c1.448 0 3.851 1.6 5.354 2.714V4.129c-1.535.961-4.03 2.408-5.241 2.459h-.014a.044.044 0 00-.019 0l-8.137-.032 1.23 7.968.05.018 6.774-.04zm-8.362-.089L6.071 6.549h-.324a3.725 3.725 0 00-3.247 3.7A3.718 3.718 0 003.616 12.9a8.618 8.618 0 003.668 1.514z"
}));

function SvgActions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default SvgActions;